<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-ttl" id="toc"><b>Table of Contents</b></p>
<p class="center">___________________</p>
<p class="toc"><a href="#/Text/intro">Introduction by Salar Abdoh</a></p>
<p class="toc"><a href="#/Text/part1">PART I: THE CRIME PAGES</a></p>
<p class="toc1"><a href="#/Text/chap1">The Fat, Fat Story of the Fat City</a></p>
<p class="toc2">D<span class="small">ANIAL</span> H<span class="small">AGHIGHI</span></p>
<p class="toc2"><i>Mowlavi</i></p>
<p class="toc1"><a href="#/Text/chap2">Fear Is the Best Keeper of Secrets</a></p>
<p class="toc2">V<span class="small">ALI</span> K<span class="small">HALILI</span></p>
<p class="toc2"><i>Rey</i></p>
<p class="toc1"><span href="#/Text/chap3" title="Link target outside of Sample">A Woman's Geography Is Sacred</span></p>
<p class="toc2">L<span class="small">ILY</span> F<span class="small">ARHADPOUR</span></p>
<p class="toc2"><i>University of Tehran</i></p>
<p class="toc"><span href="#/Text/part2" title="Link target outside of Sample">PART II: WHEN A WAR'S NOT OVER</span></p>
<p class="toc1"><span href="#/Text/chap4" title="Link target outside of Sample">The Shelf Life of Revenge</span></p>
<p class="toc2">S<span class="small">IMA</span> S<span class="small">AEEDI</span></p>
<p class="toc2"><i>Karim-Khan, Villa</i></p>
<p class="toc1"><span href="#/Text/chap5" title="Link target outside of Sample">The Corpse Fixer</span></p>
<p class="toc2">M<span class="small">AJED</span> N<span class="small">EISI</span></p>
<p class="toc2"><i>Shahrak-e-Gharb</i></p>
<p class="toc1"><span href="#/Text/chap6" title="Link target outside of Sample">Lariyan's Day in the Sun</span></p>
<p class="toc2">A<span class="small">IDA</span> M<span class="small">ORADI</span> A<span class="small">HANI</span></p>
<p class="toc2"><i>Qeytarieh</i></p>
<p class="toc1"><span href="#/Text/chap7" title="Link target outside of Sample">The Whitest Set of Teeth in Tehran</span></p>
<p class="toc2">S<span class="small">ALAR</span> A<span class="small">BDOH</span></p>
<p class="toc2"><i>Karim-Khan, Kuche Aban</i></p>
<p class="toc"><span href="#/Text/part3" title="Link target outside of Sample">PART III: PROPER BURIAL</span></p>
<p class="toc1"><span href="#/Text/chap8" title="Link target outside of Sample">The Restlessness of a Serial Killer at the Finish Line</span></p>
<p class="toc2">J<span class="small">AVAD</span> A<span class="small">FHAMI</span></p>
<p class="toc2"><i>Shush</i></p>
<p class="toc1"><span href="#/Text/chap9" title="Link target outside of Sample">My Own Marble Jesus</span></p>
<p class="toc2">M<span class="small">AHSA</span> M<span class="small">OHEBALI</span></p>
<p class="toc2"><i>Dibaji</i></p>
<p class="toc1"><span href="#/Text/chap10" title="Link target outside of Sample">In the Flophouse</span></p>
<p class="toc2">F<span class="small">ARHAAD</span> H<span class="small">EIDARI</span> G<span class="small">OORAN</span></p>
<p class="toc2"><i>Gomrok</i></p>
<p class="toc1"><span href="#/Text/chap11" title="Link target outside of Sample">A Stoning Before Breakfast</span></p>
<p class="toc2">A<span class="small">ZARDOKHT</span> B<span class="small">AHRAMI</span></p>
<p class="toc2"><i>Salehabad</i></p>
<p class="toc"><span href="#/Text/part4" title="Link target outside of Sample">PART IV: THE EXECUTIONER'S SONG</span></p>
<p class="toc1"><span href="#/Text/chap12" title="Link target outside of Sample">Bridge of Simon</span></p>
<p class="toc2">Y<span class="small">OURIK</span> K<span class="small">ARIM-</span>M<span class="small">ASIHI</span></p>
<p class="toc2"><i>Narmak</i></p>
<p class="toc1"><span href="#/Text/chap13" title="Link target outside of Sample">Not Every Bullet is Meant for a King</span></p>
<p class="toc2">H<span class="small">OSSEIN</span> A<span class="small">BKENAR</span></p>
<p class="toc2"><i>Shapur</i></p>
<p class="toc1"><span href="#/Text/chap14" title="Link target outside of Sample">The Groom's Return</span></p>
<p class="toc2">M<span class="small">AHAK</span> T<span class="small">AHERI</span></p>
<p class="toc2"><i>Behesht e Zahra Cemetery</i></p>
<p class="toc1"><span href="#/Text/chap15" title="Link target outside of Sample">The Gravedigger's Kaddish</span></p>
<p class="toc2">G<span class="small">INA</span> B. N<span class="small">AHAI</span></p>
<p class="toc2"><i>Tehrangeles</i></p>
<p class="toc1"><span href="#/Text/glossary" title="Link target outside of Sample">Persian Glossary</span></p>
<p class="toc1"><span href="#/Text/bio" title="Link target outside of Sample">About the Contributors</span></p>
<p class="toc1"><span href="#/Text/extra" title="Link target outside of Sample">Bonus Materials</span></p>
<p class="toc2"><span href="#/Text/twilight" title="Link target outside of Sample">Excerpt from <i>Tehran at Twilight</i> by Salar Abdoh</span></p>
<p class="toc1"><span href="#/Text/noir" title="Link target outside of Sample">Also in Akashic Noir Series</span></p>
<p class="toc1"><span href="#/Text/award" title="Link target outside of Sample">Akashic Noir Series Awards &amp; Recognition</span></p>
<p class="toc1"><span href="#/Text/akb" title="Link target outside of Sample">About Akashic Books</span></p>
<p class="toc1"><span href="#/Text/copy" title="Link target outside of Sample">Copyrights &amp; Credits</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2bb72d02